import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import InstrumentSocket from "./InstrumentSocket";
import "./Instruments.css";

const Instruments = ({
  priceHistory = [],
  latestCloses = {},
  latestBaseCloses = {},
  onSelect,
  getPriceHistory,
  onClose,
  isMobile = false,
  selectedCompanyId,
}) => {
  return (
    <div className="instruments-container bg-gray-900 flex flex-col h-full min-h-0">
      {/* Fixed Header */}
      <div className="flex items-center justify-between px-3 py-3  border-b border-gray-800 shrink-0">
        {/* <h2 className="text-xl w-full font-semibold text-center text-white">Markets</h2> */}
        {isMobile && (
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors"
          >
            <FontAwesomeIcon icon={faXmark} className="text-lg text-gray-400" />
          </button>
        )}
      </div>

      {/* Fixed Search */}
      <div className="px-6 py-4 border-b border-gray-800 shrink-0">
        <div className="relative">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
          />
          <input
            type="text"
            placeholder="Search assets..."
            onChange={(e) => getPriceHistory(e.target.value)}
            className="w-full pl-12 pr-5 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 transition-colors"
          />
        </div>
      </div>

      {/* Scrollable List — NOW FULLY WORKING */}
      <ScrollArea.Root className="flex-1 min-h-0 overflow-hidden">
        <ScrollArea.Viewport className="w-full h-full">
          <div className="p-4 space-y-3 pb-20"> {/* pb-20 to avoid content hidden behind scrollbar */}
            {priceHistory.length === 0 ? (
              <div className="text-center py-20 text-gray-500">
                <p className="text-lg font-medium">No assets found</p>
                <p className="text-sm mt-2">Try a different search term</p>
              </div>
            ) : (
              priceHistory.map((item) => {
                const companyId = item.Company?.id || item.id;
                return (
                  <InstrumentSocket
                    key={companyId}
                    item={item}
                    latestClose={latestCloses[companyId] ?? 0}
                    latestBaseCloses={latestBaseCloses[companyId] ?? 0}
                    onSelect={onSelect}
                    isActive={companyId === selectedCompanyId}
                  />
                );
              })
            )}
          </div>
        </ScrollArea.Viewport>

        {/* Custom Scrollbar */}
        <ScrollArea.Scrollbar
          className="flex w-2.5 bg-gray-800/50 transition-colors duration-200 hover:bg-gray-700"
          orientation="vertical"
        >
          <ScrollArea.Thumb className="flex-1 bg-blue-500 rounded-full relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
        </ScrollArea.Scrollbar>

        <ScrollArea.Corner className="bg-transparent" />
      </ScrollArea.Root>
    </div>
  );
};

export default Instruments;